import {
    HttpResponse,
    ShiftFileModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ShiftFilesDataService implements CrudService<ShiftFileModel, ShiftFileModel> {
    getAll(query: CrudDataQuery<ShiftFileModel>): Promise<CrudEnumerableResponse<ShiftFileModel>> {
        return ApiService.api.getShiftFileBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ShiftFileModel>): Promise<CrudEnumerableResponse<ShiftFileModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ShiftFileModel>> {
        return ApiService.api.getShiftFileById(id, params);
    }

    create(item: ShiftFileModel, params?: RequestParams): Promise<CrudResponse<ShiftFileModel>> {
        return ApiService.api.insertShiftFile(item, params);
    }

    update(item: ShiftFileModel, params?: RequestParams): Promise<ShiftFileModel> {
        return ApiService.api.updateShiftFile(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ShiftFileModel> {
        return ApiService.api.patchShiftFile(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ShiftFileModel>): Promise<CrudEnumerableResponse<ShiftFileModel>> {
        return ApiService.api.deleteShiftFiles(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationShiftFile(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ShiftFileModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ShiftFileModel, params?: RequestParams): Promise<CrudResponse<ShiftFileModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getShiftFileGroupped(query, params);
    }

}
